import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import WithSidebar from 'components/Layout/WithSidebar';
import InactivityModal from 'components/Inactivity';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';

function AuthRoute() {
  const isLogin = useAppSelector(selectUserSignInStatus);
  const location = useLocation();

  if (!isLogin) {
    const currentPath = location.pathname;
    const queryParams = location.search;

    return (
      <Navigate
        to={{ pathname: '/sign-in', search: location.search }}
        state={{
          fromPath: currentPath,
          fromQuery: queryParams,
        }}
        replace
      />
    );
  }

  return (
    <WithSidebar>
      <InactivityModal />
      <Outlet />
    </WithSidebar>
  );
}

export default AuthRoute;
